export default class Fixed {
  constructor() {
    this.fixed = document.querySelector('.l-fixed');
    this.fixedContact = document.querySelector('.l-fixed-contact');
    this.fixedContactPc = document.querySelector('.l-fixed-contact--pc');

    // スクロール監視用のプロパティ
    this.isScrolling = false;
    this.hideThreshold = 0.95; // ページの95%スクロールしたら非表示にする

    if(this.fixed !== null) {
      this.init();
    }
  }

  init() {
    this.addEventListeners();
    // 初期状態での位置チェック
    this.checkScrollPosition();
  }

  addEventListeners() {
    // スクロールイベントの監視（パフォーマンスを考慮してthrottleを使用）
    window.addEventListener('scroll', this.throttle(this.handleScroll.bind(this), 16));

    // リサイズ時も再チェック
    window.addEventListener('resize', this.throttle(this.checkScrollPosition.bind(this), 250));
  }

  handleScroll() {
    if (!this.isScrolling) {
      this.isScrolling = true;
      requestAnimationFrame(() => {
        this.checkScrollPosition();
        this.isScrolling = false;
      });
    }
  }

  checkScrollPosition() {
    if (!this.fixedContactPc) return;

    // 現在のスクロール位置を取得
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // スクロール率を計算
    const scrollPercentage = (scrollTop + windowHeight) / documentHeight;

    // 設定した閾値を超えたら非表示クラスを付与
    if (scrollPercentage >= this.hideThreshold) {
      this.fixedContactPc.classList.add('is-hide');
    } else {
      this.fixedContactPc.classList.remove('is-hide');
    }
  }

  // パフォーマンス向上のためのthrottle関数
  throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }
}
